import { Component } from '@angular/core';

@Component({
  selector: 'hdw-about-organ-tool',
  templateUrl: './about-organ-tool.component.html',
  styleUrls: ['./about-organ-tool.component.scss']
})
export class AboutOrganToolComponent {}
